import { defineRouting } from 'next-intl/routing'
import { APP_DEFAULT_LOCALE, APP_LOCALES } from '@/constants/i18n.constants'

export const routing = defineRouting({
  // A list of all supported locales
  locales: APP_LOCALES,
  defaultLocale: APP_DEFAULT_LOCALE,
  // automatic http-header alternate link creation disabled, we create hreflang attributes in html
  alternateLinks: false,
  localeDetection: false,
  localePrefix: 'as-needed',
})
